import { all, call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import { fetchLockedVisitsAPI } from '../../../services/group-admin-service';
import { FETCH_LOCKED_VISITS, FETCH_LOCKED_VISITS_ERROR, FETCH_LOCKED_VISITS_START, FETCH_LOCKED_VISITS_SUCCESS, SET_LOCKED_VISITS_PAGINATION } from '../../actions/groupadmin/lockedActions';

function* fetchGroupAdminLockedVisits({ payload }) {
    try {
        yield put({ type: FETCH_LOCKED_VISITS_START })
        let response = yield call(fetchLockedVisitsAPI, payload);
        if (response.data) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_LOCKED_VISITS_SUCCESS, locked: response.data.locked })
            yield put({ type: SET_LOCKED_VISITS_PAGINATION, pagination });
        } else {
            yield put({ type: FETCH_LOCKED_VISITS_ERROR });
            message.error('Failed to fetch locked visits!');
        }

    } catch (error) {
        message.error('Failed to fetch locked visits!');
        yield put({ type: FETCH_LOCKED_VISITS_ERROR, error })
    }

}

function* fetchGroupAdminLockedWatcher() {
    yield takeLatest(FETCH_LOCKED_VISITS, fetchGroupAdminLockedVisits)
}

export default function* rootSaga() {
    yield all([
        fetchGroupAdminLockedWatcher()
    ]);
}